module.exports = __webpack_public_path__ + "static/media/EYInterstate-Regular.ee66cdd8.eot";